module.exports = __webpack_public_path__ + "img/logo_tc.885b95bb.png";